// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3BZt1","obliqueLineWrap":"membershipbadge_obliqueLineWrap__3hZGI","obliqueLine":"membershipbadge_obliqueLine__2HlXq"};